module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-common', {
    attrs: {
      "type": "normal",
      "showAppTopLink": _vm.isSharePage,
      "showAppBotLink": false,
      "detail": _vm.dataAll
    }
  }, [_c('div', {
    staticClass: "wrapper",
    style: ((!_vm.isSharePage) ? {
      height: '100vh'
    } : {})
  }, [_c('button', {
    staticClass: "content-button"
  }), _vm._v(" "), _c('video', {
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.data.resources ? _vm.data.resources[1].url : '',
      "poster": _vm.data.image ? _vm.data.image : '',
      "controlslist": "nodownload",
      "x-webkit-airplay": "allow",
      "webkit-playsinline": "playsinline",
      "x5-video-orientation": "portraint",
      "x5-video-player-type": "h5-page",
      "webkit-appearance": "none",
      "playsinline": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "info-bottom"
  }, [_c('p', {
    staticClass: "info-auth"
  }, [_vm._v("@" + _vm._s(_vm.authors))]), _vm._v(" "), _c('p', {
    ref: "dsc",
    staticClass: "info-desc",
    class: _vm.showMoreDesc ? 'showmore' : ''
  }, [_vm._v(_vm._s(_vm.desc) + " "), _c('span', {
    ref: "morebtn",
    staticClass: "info-more",
    on: {
      "click": _vm.showMore
    }
  }, [_vm._v(_vm._s(_vm.showMoreDesc ? '收起' : '更多')), _c('span', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": require("../images/btn_open_video.png")
    }
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bdd94b2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/film.vue
// module id = 862
// module chunks = 2